import React, { useEffect, useState } from "react";
import {
  HamburgerIcon,
  HeaderTitle,
  MenuItem,
  MenuItemTitle,
  MenuWrapper,
  NestedSubMenuItem,
  SidebarContainer,
  SidebarHeader,
  SubMenuItem,
} from "../StyledComp";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { citizenBaseUrl } from "../../../pages/citizen/citizenPageUrls";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import flags from "@egovernments/digit-ui-module-common/src/config/citizenSidebar";
import { useTranslation } from "react-i18next";

//import useDepartmentSelector from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/hooks/useDepartmentSelector";
dayjs.extend(customParseFormat);
const Sidebar = ({ userDetails, toggleSidebar, collapsed }) => {
  const { t } = useTranslation()
  // console.log("processEnv", flags);

  const [expandedItems, setExpandedItems] = useState({});
  const [expandedSubItems, setExpandedSubItems] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const history = useHistory();
  const userInfo = Digit.UserService.getUser();
  const userRoles = userInfo?.info?.roles?.map((e) => e.code);
  const userDetail = Digit.SessionStorage.get("USER_DETAIL") || userDetails;
  const [isValidityExpired, setIsValidityExpired] = useState(null);
  const [isValidityNull, setIsValidityNull] = useState(null);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  //const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  // console.log(userDetails, "userdata");

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.3)", // slight dim
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    noticeBox: {
      background: "#fff",
      padding: "25px 30px",
      borderRadius: "10px",
      width: "380px",
      textAlign: "center",
      boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
      borderTop: "5px solid #ff9800",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "10px",
    },
    message: {
      fontSize: "14px",
      color: "#444",
      marginBottom: "20px",
    },
    button: {
      padding: "8px 20px",
      background: "#ff9800",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontWeight: "500",
    },
  };

  useEffect(() => {
    // console.log(userDetail, "calling userDetail");
    if (!userDetail) return;
    if (!userDetail?.validUpto) {
      setIsValidityNull(true);
      setIsValidityExpired(true);
      return;
    }
    //Migrated user validty data present and date valid
    //Migrated user validty data present and date is not valid
    //Re-apply valid true but date expired
    //Apply new user validity null no validity data
    const validUpto = dayjs(userDetail?.validUpto, "DD-MM-YYYY HH:mm:ss");
    const now = dayjs();
    const expired = validUpto.isBefore(now);
    // console.log("Is Expired:", expired, now, validUpto.format("DD-MM-YYYY"), userDetail?.validUpto);
    setIsValidityExpired(expired);
  }, [userDetail]);
  // console.log(isValidityExpired, "checkexpired");

  // Role detection logic
  const isLtp = userRoles?.some((role) => !["OWNER", "EMPLOYEE"].includes(role)) && !isValidityExpired && userRoles?.length > 2;
  const expiredLTP = userRoles?.some((role) => !["OWNER", "EMPLOYEE"].includes(role)) && isValidityExpired;
  const isOwner = userRoles?.includes("OWNER") && !isLtp;
  const isCitizen = userRoles?.includes("LTP") && !isLtp;
  // console.log(isCitizen, isLtp, isOwner, isValidityExpired, "call");

  const fileCount = Digit.SessionStorage.get("FILE_COUNT") || "---";
  const toggleItem = (item) => {
    setExpandedItems((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };
  // console.log("flagsfromsidebar", flags);

  const toggleSubItem = (parentTitle, subItemName) => {
    setExpandedSubItems((prev) => ({
      ...prev,
      [`${parentTitle}-${subItemName}`]: !prev[`${parentTitle}-${subItemName}`],
    }));
  };
  const handleNavigation = (path, state = {}, keysToRemove = []) => {
    // Remove specified keys from session storage
    if (
      path.includes("/obps/services/") // all Apply portals
    ) {
      Digit.SessionStorage.del("CITIZEN.COMMON.HOME.FLOW");
      Digit?.SessionStorage.del("LTP.SCRUTINY.SELECTION");
    }
    if (keysToRemove.length > 0) {
      keysToRemove.forEach((key) => {
        Digit.SessionStorage.del(key);
      });
    }
    history.push(path, state);
  };

  const allMenuItems = [
    {
      title: `${t("FASTPAS.FILES.RECEIVED.TEXT")} (${fileCount})`,
      path: `${citizenBaseUrl}/profile`,
    },
    // {
    //   title: `Know Your Property`,
    //   path: `${citizenBaseUrl}/obps/services/propertyPortal`, // Direct path
    // },
    {
      title: t("FASTPAS.GLOBAL.LTP.TEXT"),
      subItems: [
        {
          name: isValidityNull ? t("FASTPAS.GLOBAL.APPLY.TEXT") : isValidityExpired ? "Reapply" : t("FASTPAS.GLOBAL.APPLY.TEXT"),
          path: `${citizenBaseUrl}/obps/services/ltpPortal`,
        },
        {
          name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
          path: `${citizenBaseUrl}/obps/formProfessionalApplications`,
        },
      ],
    },

    {
      title: t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT"),
      subItems: [
        { name: t("FASTPAS.GLOBAL.APPLY.TEXT"), path: `${citizenBaseUrl}/obps/services/formLandUse` },
        { name: t('FASTPAS.GLOBAL.APPLY.OLD.CASE.TEXT'), path: `${citizenBaseUrl}/obps/services/oldCaseSearchLU` },
        { name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"), path: `${citizenBaseUrl}/obps/formLandUseApplications` },
      ],
    },
    // {
    //   title: "Purchasable FAR",
    //   subItems: [
    //     { name: "Apply", path: `${citizenBaseUrl}/obps/services/purchasableFAR` },
    //     { name: "My Application", path: `${citizenBaseUrl}/obps/purchasableFarApplications` },
    //   ],
    // },
    {
      title: t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT"),
      subItems: [
        {
          name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
          subItems: [
            flags.edcr && {
              name: t('FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT'),
              path: `${citizenBaseUrl}/obps/services/groupHousingPortal`,
            },

            flags.selfCert && {
              name: "Self Certification via Registration (Residential-upto 100 Sqm & Commercial-upto 30 Sqm)",
              path: `${citizenBaseUrl}/obps/services/selfResidentialPortal`,
            },

            flags.selfApproval && {
              name: "Self Approval via LTP",
              subItems: [
                flags.selfApprovalScheme && {
                  name: "Scheme Residential upto 500 Sqmt & Commercial upto 200 Sqmt.",
                  path: `${citizenBaseUrl}/obps/services/selfApprovalPortal`,
                },
                flags.selfApprovalNonScheme && {
                  name: "Non-Scheme Residential upto 300 Sqmt.",
                  path: `${citizenBaseUrl}/obps/services/selfApprovalPortal`,
                },
              ].filter(Boolean),
            },
            //flags.revalidation && { name: "Revalidation/Time Extension", path: `${citizenBaseUrl}/obps/services/mapRevalidation` },
            //flags.groupHousing && { name: "Group Housing Portal", path: `${citizenBaseUrl}/obps/services/groupHousingPortal` },
            // { name: "Revalidation/Time Extension", path: `${citizenBaseUrl}/obps/services/mapRevalidation` },
            // { name: "Group Housing Portal", path: `${citizenBaseUrl}/obps/services/groupHousingPortal` },
          ].filter(Boolean),
        },
        { name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"), path: `${citizenBaseUrl}/obps/mapSubApplications` },
        { name: t("FASTPAS.GLOBAL.COMPOUNDING.APP.TEXT"), path: `${citizenBaseUrl}/obps/compoundingApplications` },
      ],
    },

    flags.plinth && {
      title: t('FASTPAS.GLOBAL.PLINTH.SUB.TEXT'),
      subItems: [
        { name: t("FASTPAS.GLOBAL.APPLY.TEXT"), path: `${citizenBaseUrl}/obps/services/plinthPortal` },
        { name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"), path: `${citizenBaseUrl}/obps/plinthApplications` },
      ],
    },
    flags.landUseConversion && {
      title: t("FASTPAS.GLOBAL.LAND.USE.TEXT"),
      subItems: [
        // { name: t("FASTPAS.GLOBAL.APPLY.TEXT"), path: `${citizenBaseUrl}/obps/services/LandUseConversion` },
        { name: t("FASTPAS.GLOBAL.INV.SUGG.OBJ.TEXT"), path: `${citizenBaseUrl}/obps/services/formSuggestion` },
        { name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"), path: `${citizenBaseUrl}/obps/formLandUseConversionApplications` },
        { name: t("FASTPAS.GLOBAL.MY.SUG.APP.TEXT"), path: `${citizenBaseUrl}/obps/formSuggestionApplications` },
      ],
    },

    flags.workCommencement && {
      title: t("FASTPAS.GLOBAL.WORK.COM.TEXT"),
      subItems: [
        { name: t("FASTPAS.GLOBAL.APPLY.TEXT"), path: `${citizenBaseUrl}/obps/services/WorkCommencementModule` },
        { name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"), path: `${citizenBaseUrl}/obps/WorkCommencementModule` },
      ],
    },
    flags.completion && {
      title: t("FASTPAS.GLOBAL.COMPLETITION.MODULE.TEXT"),
      subItems: [
        { name: t("FASTPAS.GLOBAL.APPLY.TEXT"), path: `${citizenBaseUrl}/obps/services/completionPortal` },
        { name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"), path: `${citizenBaseUrl}/obps/completionApplications` },
      ],
    },

    flags.purchasableFar && {
      title: t("FASTPAS.GLOBAL.PUR.FAR.MODULE.TEXT"),
      subItems: [
        { name: t("FASTPAS.GLOBAL.APPLY.TEXT"), path: `${citizenBaseUrl}/obps/services/purchasablePortal` },
        { name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"), path: `${citizenBaseUrl}/obps/pFARApplications` },
      ],
    },
    // {
    //   title: "Compounding Module",
    //   subItems: [
    //     { name: "Apply", path: `${citizenBaseUrl}/obps/services/compoundingModule` },
    //     { name: "My Application", path: `${citizenBaseUrl}/obps/plinthApplications` },
    //   ],
    // },
    {
      title: t("FASTPAS.GLOBAL.MAKEPAYMENT.TEXT"),
      path: `${citizenBaseUrl}/obps/Payment/Applications`,
    },
  ].filter(Boolean);

  let menuItems = [];

  if (isCitizen) {
    // Citizen sees only Technical Professional Registration with all options
    menuItems = allMenuItems.filter((item) => item.title === t("FASTPAS.GLOBAL.LTP.TEXT"));
  } else if (isOwner) {
    // Owner sees all tabs but Apply only in Technical Professional
    menuItems = allMenuItems.map((item) => {
      // Keep full structure for Land Use Verification and Land Use Conversion Module
      if (
        item.title === t("FASTPAS.GLOBAL.LTP.TEXT") ||
        item.title === t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT") ||
        item.title === t("FASTPAS.GLOBAL.LAND.USE.TEXT")
      ) {
        return item;
      }
      // For Map Submission, filter specific option
      if (item.title === t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT")) {
        return {
          ...item,
          subItems: item?.subItems?.map((subItem) => {
            if (subItem.name === t("FASTPAS.GLOBAL.APPLY.TEXT") && subItem.subItems) {
              return {
                ...subItem,
                subItems: subItem?.subItems?.filter((nested) => nested?.name?.includes("Self Certification via Registration")),
              };
            }
            return subItem;
          }),
        };
      }
      // For other items, remove Apply option
      return {
        ...item,
        subItems: item?.subItems?.filter((subItem) => subItem.name !== t("FASTPAS.GLOBAL.APPLY.TEXT")),
      };
    });
  } else if (isLtp) {
    // LTP sees all tabs but Technical Professional without Apply
    menuItems = allMenuItems.map((item) => {
      if (item.title === t("FASTPAS.GLOBAL.LTP.TEXT")) {
        return {
          ...item,
          subItems: item?.subItems?.filter((subItem) => subItem.name !== t("FASTPAS.GLOBAL.APPLY.TEXT")),
        };
      }
      // For Map Submission, filter out Self Certification option
      if (item.title === t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT")) {
        return {
          ...item,
          subItems: item.subItems.map((menu) => {
            if (menu.name === t("FASTPAS.GLOBAL.APPLY.TEXT")) {
              return {
                ...menu,
                subItems: menu.subItems.filter(
                  (subItem) => subItem.name !== "Self Certification via Registration (Residential-upto 100 Sqm & Commercial-upto 30 Sqm)"
                ),
              };
            }
            return menu;
          }),
        };
      }

      return item;
    });
  } else if (expiredLTP) {
    menuItems = allMenuItems.filter((item) => item.title === t("FASTPAS.GLOBAL.LTP.TEXT"));
  } else {
    // Default case (if needed)
    menuItems = allMenuItems;
  }
  // if (applicationFlow === null) {
  //   return <DepartmentSelector />;
  // }

  return (
    <React.Fragment>
      <SidebarContainer collapsed={collapsed}>
        <SidebarHeader>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              className="sidebr-logo mr-3"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Seal_of_Uttar_Pradesh.svg/800px-Seal_of_Uttar_Pradesh.svg.png%22"
            />
            {/* <HeaderTitle>Development Authority</HeaderTitle> */}
            <HeaderTitle>FASTPAS</HeaderTitle>
          </div>
          <HamburgerIcon onClick={toggleSidebar} />
        </SidebarHeader>

        <MenuWrapper collapsed={collapsed} className="all-menu-wrapper">
          {menuItems.map((item) => (
            <div key={item.title} className={history.location.pathname === item.path ? "single-node active" : "single-node"}>
              {item.subItems ? (
                // This is a menu item with sub-items
                <React.Fragment>
                  <MenuItem onClick={() => toggleItem(item.title)}>
                    <MenuItemTitle>{item.title}</MenuItemTitle>
                    <div>{expandedItems[item.title] ? <FaChevronUp /> : <FaChevronDown />}</div>
                  </MenuItem>

                  {expandedItems[item.title] && (
                    <div>
                      {item.subItems.map((subItem) => (
                        <React.Fragment key={subItem.name}>
                          {subItem.subItems ? (
                            <React.Fragment>
                              <SubMenuItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleSubItem(item.title, subItem.name);
                                }}
                              >
                                <span>{subItem.name}</span>
                                <div>{expandedSubItems[`${item.title}-${subItem.name}`] ? <FaChevronUp /> : <FaChevronDown />}</div>
                              </SubMenuItem>

                              {expandedSubItems[`${item.title}-${subItem.name}`] && (
                                <div>
                                  {subItem.subItems.map((nestedSubItem) => (
                                    <React.Fragment key={nestedSubItem.name}>
                                      {nestedSubItem.subItems ? (
                                        // Third level of nesting (Self Approval via LTP dropdown)
                                        <React.Fragment>
                                          <NestedSubMenuItem
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleSubItem(`${item.title}-${subItem.name}`, nestedSubItem.name);
                                            }}
                                          >
                                            <span>{nestedSubItem.name}</span>
                                            <div>
                                              {expandedSubItems[`${item.title}-${subItem.name}-${nestedSubItem.name}`] ? (
                                                <FaChevronUp />
                                              ) : (
                                                <FaChevronDown />
                                              )}
                                            </div>
                                          </NestedSubMenuItem>

                                          {expandedSubItems[`${item.title}-${subItem.name}-${nestedSubItem.name}`] && (
                                            <div>
                                              {nestedSubItem.subItems.map((deeperNestedSubItem) => (
                                                <NestedSubMenuItem
                                                  key={deeperNestedSubItem.name}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    const keysToRemove = deeperNestedSubItem.name.includes("Scheme")
                                                      ? ["OWNER_INFO", "FASTPAS_ID", "FILE_NO"]
                                                      : [];
                                                    handleNavigation(deeperNestedSubItem.path, {}, keysToRemove);
                                                  }}
                                                  className={
                                                    history.location.pathname === deeperNestedSubItem.path
                                                      ? "submenu-item-active nested-single-menus"
                                                      : "nested-single-menus"
                                                  }
                                                  active={history.location.pathname === deeperNestedSubItem.path}
                                                >
                                                  <span>{deeperNestedSubItem.name}</span>
                                                </NestedSubMenuItem>
                                              ))}
                                            </div>
                                          )}
                                        </React.Fragment>
                                      ) : (
                                        // Regular nested item (no further sub-sub-items)
                                        <NestedSubMenuItem
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleNavigation(nestedSubItem.path);
                                          }}
                                          className={
                                            history.location.pathname === nestedSubItem.path
                                              ? "submenu-item-active nested-single-menus"
                                              : "nested-single-menus"
                                          }
                                          active={history.location.pathname === nestedSubItem.path}
                                        >
                                          <span>{nestedSubItem.name}</span>
                                        </NestedSubMenuItem>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </div>
                              )}
                            </React.Fragment>
                          ) : (
                            <SubMenuItem
                              onClick={(e) => {
                                e.stopPropagation();

                                const isLandUseApply = item.title === t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT") && subItem.name === t("FASTPAS.GLOBAL.APPLY.TEXT");

                                if (isOwner && isLandUseApply) {
                                  setPendingNavigation({
                                    path: subItem.path,
                                    state: {},
                                    keysToRemove: ["FORMLANDUSE"],
                                  });
                                  setShowPopup(true);
                                  return;
                                }

                                const keysToRemove = isLandUseApply ? ["FORMLANDUSE"] : [];

                                if (subItem.name === "Reapply") {
                                  handleNavigation(subItem.path, { reapply: true }, keysToRemove);
                                } else {
                                  handleNavigation(subItem.path, {}, keysToRemove);
                                }
                              }}
                            >
                              <span>{subItem.name}</span>
                            </SubMenuItem>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  )}
                </React.Fragment>
              ) : (
                // This is a direct link menu item
                <MenuItem
                  onClick={() => handleNavigation(item.path)}
                  className={history.location.pathname === item.path ? "submenu-item-active nested-single-menus" : "nested-single-menus"}
                  active={history.location.pathname === item.path}
                >
                  <MenuItemTitle>{item.title}</MenuItemTitle>
                </MenuItem>
              )}
            </div>
          ))}
        </MenuWrapper>
      </SidebarContainer>
      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.noticeBox}>
            <div style={styles.title}>Notice</div>
            <div style={styles.message}>This land use verification is not applicable for map submission.</div>
            <button
              style={styles.button}
              onClick={() => {
                setShowPopup(false);

                if (pendingNavigation) {
                  handleNavigation(pendingNavigation.path, pendingNavigation.state, pendingNavigation.keysToRemove);
                  setPendingNavigation(null);
                }
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Sidebar;
